import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-rounded-arrow-down",
  "use": "tamr-icon-rounded-arrow-down-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-rounded-arrow-down\"><path d=\"M24.9,9.5l-8.1,13a1,1,0,0,1-1.6,0L6.2,9.5A1,1,0,0,1,7,8h17A1,1,0,0,1,24.9,9.5Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol